import { Attribute } from '../../../../../../components/core-v2'
import { formatCurrencyFull } from '../../../../../../utilities/currency'
import { TopupWithdrawStepState } from '../../../../../trade-editor/modules/01-topup-withdraw/state/topup-withdraw-slice'
import { TopUpWithdrawState } from '../../../../../trade-editor/types/TopUpWithdrawState'
import { ApprovalBox } from '../../molecules/approval-box'
import { ConfirmationBox } from '../../molecules/confirmation-box'
import { ApprovalProps } from './types'

type Props = ApprovalProps & {
  state: TopupWithdrawStepState
}

export const ApproveTopUpWithdraw = ({
  isApproved,
  onChangeIsApproved,
  onClickEdit,
  state
}: Props) => {
  const title = state.topUpWithrawState === TopUpWithdrawState.Topup ? 'Top up' : 'Withdraw'

  return (
    <ApprovalBox isApproved={isApproved} title={title}>
      <Attribute name="Current balance (Rand)">
        {formatCurrencyFull(state.currentAmount, state.currency)}
      </Attribute>
      {state.topUpWithrawState === TopUpWithdrawState.Topup && (
        <Attribute name="Top up amount (Rand)">
          {formatCurrencyFull(state.changeAmount, state.currency)}
        </Attribute>
      )}
      {state.topUpWithrawState === TopUpWithdrawState.Withdraw && (
        <Attribute name="Withdraw amount (Rand)">
          {formatCurrencyFull(state.changeAmount, state.currency)}
        </Attribute>
      )}

      <Attribute name="New (Rand)">
        {formatCurrencyFull(state.newBalance, state.currency)}
      </Attribute>

      <ConfirmationBox
        elementTitle={title}
        isApproved={isApproved}
        isAre="is"
        onChangeIsApproved={onChangeIsApproved}
        onClickEdit={onClickEdit}
      />
    </ApprovalBox>
  )
}
